<template>
  <div>
  
    <div class="container-fluid">
      <div class="row page">
       <div class="card mt-4 pt-3 px-3 h-100 full-page-card">
          <div class="row">
            <div class="col-6">
              <h2 class="card-title">User Management</h2>
            </div>
            <div class="col-6 text-right" v-if="selectedUser">
              <button @click="onSuspendClick" class="btn" :class="{'btn-warning':!selectedUser.suspended, 'btn-danger': selectedUser.suspended}">Suspend{{ selectedUser.suspended?'ed':''}}</button>
              <button @click="onSaveClick" class="btn btn-primary">Save</button>
            </div>
          </div>
          <div class="full-page-card__content d-flex flex-column h-100">
            <div class="row" style="flex-grow:1; overflow:hidden">
              <!-- Search column -->
              <div class="col-3 scrollable h-100 ">
                <!-- Search box -->
                <div class="form-group pt-3 bg-white" style="position:sticky; top:0">
                  <input class="form-control" v-model="searchTerm" placeholder="Search by user Name, ID or Email">
                </div>
                <!-- Result item -->
                <div class="border-bottom m-2" v-for="user in users" :key="'user-'+user.id" @click="selectUser(user)">
                  <span class="h4 float-right">#{{ user.id }}</span>
                  <h3>{{user.firstName}} {{ user.lastName }}</h3>
                  <p>{{ getTimeSinceJoined(user)  }}</p>
                </div>
              </div>
              <!-- Right column -->
              <div class="col-9 scrollable h-100 " v-if="selectedUser">
                <div class="row mt-3">
                  <div class="col-6">
                    <stats-card title="Total Drops" :subTitle="userStats?userStats.dropCount.toString():'-'" icon="fa fa-parachute-box"></stats-card>
                  </div>
                  <div class="col-6">
                    <stats-card title="Total Minutes" :subTitle="userStats?userStats.totalDropDuration.toString():'-'" icon="fa fa-parachute-box"></stats-card>
                  </div>
                </div>
                
                <h3>User information</h3>
                <div class="row">
                  <div class="col-6">
                    <div class="form-group">
                      <label>First name</label>
                      <input class="form-control" v-model="selectedUser.firstName">
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="form-group">
                      <label>Last name</label>
                      <input class="form-control" v-model="selectedUser.lastName">
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-6">
                     <div class="form-group">
                      <label>Mobile</label>
                      <input class="form-control" v-model="selectedUser.mobile">
                    </div>
                  </div>
                  <div class="col-6 mb-4">
                    <div class="form-group">
                      <label>Email</label>
                      <input class="form-control" v-model="selectedUser.email">
                    </div>
                  </div>
                </div>
                <admin-user-drops-card
                  title="Past Drops"
                  v-if="userPastDrops"
                  usePagination="true"
                  :drops="userPastDrops"
                  :resultsPerPage="5"
                  @updated="selectUser(selectedUser)"
                ></admin-user-drops-card>
                <!--  -->
                <div class="col-12 mt-2" v-if="userStats">
                  <h2>Connected Charities</h2>

                  <el-table class="table-responsive table-flush"
                            header-row-class-name="thead-light"
                            :data="userStats.charities">
                    <el-table-column label="Branch"
                                min-width="150px"
                                prop="branch"
                                >
                      <template v-slot="{row}">
                        <LocationIcon avatarSize="sm" :name="row.name" :logo="row.logoUrl"></LocationIcon>                          
                      </template>
                    </el-table-column>
                    <el-table-column label="Drops"
                                prop="drop"
                                >
                      <template v-slot="{row}">
                        <div class="col-3 text-center">{{row.dropCount}}</div>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
                <div></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
  </div>
</template>
<script>

  import RetailersLeadService from '../../../services/RetailerLeadsService';
  import RetailersService from '../../../services/RetailersService';
  import StatsService from '../../../services/StatsService';
  import DropsService from '../../../services/DropsService';
  import OverviewCard from '../../../components/Cards/OverviewCard';
  import UsersService from '../../../services/UsersService';
  import StatsCard from '../../../components/Cards/StatsCard';
  import AdminUserDropsCard from '../../../components/Cards/AdminUserDropsCard';
  import moment from 'moment';
  import debounce from 'debounce';
  import { Table, TableColumn, DropdownMenu, DropdownItem, Dropdown} from 'element-ui';
  import LocationIcon from '../../../components/LocationIcon';

  export default {
    name: 'user-management',

    components: {
      OverviewCard,
      AdminUserDropsCard,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      LocationIcon,
    },

    created() {
      this.init()
    },

    data() {
       return {
        users: [],
        selectedUser: null,
        userStats: null,
        userPastDrops: null,
        searchTerm: '',
        debouncedSearch: null,
        stats:null
      };
    },

    methods:{
      /**
       * 
       */
      init(){
       this.debouncedSearch = debounce(this.doSearch, 1000);
      },

      /**
       */
      async searchUsers() {
        try {
          const usersRes = await UsersService.search({query:this.searchTerm, limit:50});
          this.users = usersRes.data;
        }
        catch(err) {
          console.log('Error fetching Users', err);
          alert('There was an error fetching users from the server. Please try again.');
        }
      },

      /**
       * @param {object} user 
       */
      async selectUser(user) {
        this.selectedUser = user;
        try{
          const userStatsRes = await StatsService.getVolunteerStats(user.id);
          this.userStats = userStatsRes.data;
          const pastDropRes = await DropsService.getAllPopulated({where:{userId:user.id}, order:'date:DESC'});
          this.userPastDrops = pastDropRes.data;
        }
        catch(err){
          console.log('Error fetching User Stats', err);
          alert('There was an error fetching the selected user\'s statistics from the server. Please try again.');
        }
      },

      /**
       * 
       */
      getTimeSinceJoined(user){
        return moment().to(user.createdAt)
      },

      /**
       * 
       */
      doSearch(){
        if(this.searchTerm === '') this.users = [];
        else{
          this.searchUsers();
        }
      },

      /**
       * 
       */
      async onSaveClick(){
         try {
          const usersRes = await UsersService.update(this.selectedUser.id, this.selectedUser);
        }
        catch(err) {
          console.log('Error saving user', err);
          alert('Oops! Something went wrong, your changes have not been changed. Please try again.');
        }
      },

      /**
       * 
       */
      async onSuspendClick(){
        if(!this.selectedUser) return;
        // 
        let action = 'reinstate';
        let actionPast = 'reinstated';
        if(!this.selectedUser.suspended){
          action = 'suspend';
          actionPast = 'suspended';
        }
        // Confirm
        let confirmed = confirm(`Are you sure you want to ${action} this user, they will be ${actionPast} imediatley after you press OK`);
        if(!confirmed) return;
        // Set and save new state
        try {
          if(this.selectedUser.suspended){
            this.selectedUser.suspended = false;
            const userRes = await UsersService.reinstate(this.selectedUser.id);
          }else{
            this.selectedUser.suspended = true;
            const userRes = await UsersService.suspend(this.selectedUser.id);
          }
        }
        catch(err) {
          this.selectedUser.suspended = !this.selectedUser.suspended;
          alert('Oops! Something went wrong, the user\'s suspension state has not been saved. Please try again.');
        }
      }
    },

    watch: {
      searchTerm: function(val, preVal){
        this.debouncedSearch();
      }
    }
  };
</script>

<style>
    .page {
    display: flex;
    flex-direction: column;
    min-height: calc(100vh - 8rem);
  }
</style>

<style lang="scss" scoped>

</style>
